import http from './http'

/**
 * 获取可用临时号码列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getPhoneNumbers = (params = {}) => {
  return http.get('/phone/list', { params })
}

/**
 * 获取指定临时号码的数据记录
 * @param {string} phoneNumber - 临时号码
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getSmsMessages = (phoneNumber, params = {}) => {
  return http.get(`/message/list/${phoneNumber}`, { params })
}

/**
 * 获取所有数据记录
 * @param {Object} params - 查询参数 (page, size等)
 * @returns {Promise}
 */
export const getAllMessages = (params = {}) => {
  return http.get('/message/all', { params })
}

/**
 * 获取收取记录
 * @param {Object} params - 查询参数
 * @param {string} [params.projectId] - 项目ID
 * @param {string} [params.content] - 内容搜索
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.pageSize=10] - 每页条数
 * @returns {Promise}
 */
export const getSmsFlowRecords = (params = {}) => {
  return http.post('/smsFlow/search', params)
}

/**
 * 导出数据流水记录
 * @param {Object} params - 查询参数
 * @param {string} [params.projectId] - 项目ID
 * @param {string} [params.code] - 渠道代码
 * @returns {Promise}
 */
export const exportSmsFlowRecords = async (params = {}) => {
  try {
    const token = localStorage.getItem('tianqi-token')
    const response = await fetch(http.defaults.baseURL + '/smsFlow/export', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token || ''
      },
      body: JSON.stringify(params)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.blob()
  } catch (error) {
    console.error('导出失败:', error)
    throw error
  }
}

/**
 * 获取收取记录
 * @param {Object} params - 查询参数 (page, size等)
 * @returns {Promise}
 */
export const getReceiveRecords = (params = {}) => {
  return http.get('/message/records', { params })
}

/**
 * 标记数据消息为已读
 * @param {string} messageId - 数据消息ID
 * @returns {Promise}
 */
export const markMessageAsRead = (messageId) => {
  return http.post(`/message/read/${messageId}`)
}

/**
 * 删除数据消息
 * @param {string} messageId - 数据消息ID
 * @returns {Promise}
 */
export const deleteMessage = (messageId) => {
  return http.delete(`/message/delete/${messageId}`)
}

/**
 * 处理数据消息（例如提取共享数据）
 * @param {string} messageId - 数据消息ID
 * @param {Object} data - 处理参数
 * @returns {Promise}
 */
export const processMessage = (messageId, data = {}) => {
  return http.post(`/message/process/${messageId}`, data)
}

/**
 * 获取消息处理统计数据
 * @returns {Promise}
 */
export const getMessageStats = () => {
  return http.get('/message/stats')
}

/**
 * 获取用户数据共享使用情况
 * @returns {Promise}
 */
export const getUserSmsUsage = () => {
  return http.get('/user/sms/usage')
}

/**
 * 获取用户余额和数据共享成功率
 * @returns {Promise}
 */
export const getUserBalance = () => {
  return http.post('userWallet/getWallet', {})
}

/**
 * 获取用户数据共享成功率
 * @returns {Promise}
 */
export const getSuccessRate = () => {
  return http.post('statistic/getSuccessRate', {})
}

/**
 * 获取充值列表
 * @returns {Promise}
 */
export const getRechargeList = () => {
  return http.post('/idCard/getRechargeList', {})
}

/**
 * 搜索项目
 * @param {string} search - 搜索关键词
 * @returns {Promise}
 */
export const searchProjects = (search) => {
  return http.post('/message/RegionCollect/searchProject', { search })
}

/**
 * 获取项目渠道列表
 * @param {Object} params - 请求参数
 * @param {number} params.keyword - 项目ID
 * @param {Array} params.channelIdList - 渠道ID列表
 * @param {boolean} [params.priceSort=false] - 是否按价格排序
 * @param {number} [params.page=1] - 页码
 * @returns {Promise}
 */
export const getProjectChannels = (params) => {
  return http.post('/message/RegionCollect/search', params)
}

/**
 * 添加渠道对接
 * @param {Object} channelData - 渠道信息
 * @returns {Promise}
 */
export const addChannelConnection = (channelData) => {
  return http.post('/message/RegionCollect/add', channelData)
}

/**
 * 获取项目临时号码
 * @param {Object} params - 请求参数
 * @param {string} params.projectName - 项目名称
 * @param {string} params.code - 项目代码
 * @param {string} params.channelId - 渠道ID
 * @param {string} [params.operator] - 运营商类型，0为实卡，1为虚卡
 * @param {string} [params.phone_num] - 指定临时号码
 * @param {string} [params.scope] - 指定资源段
 * @param {string} [params.scope_black] - 排除资源段
 * @returns {Promise}
 */
export const getProjectPhone = (params) => {
  return http.post('/phone/getPhone', params)
}

/**
 * 获取临时号码共享数据
 * @param {Object} params - 请求参数
 * @param {string} params.phoneNum - 临时号码
 * @param {string} params.code - 项目代码
 * @param {string} params.channelId - 渠道ID
 * @returns {Promise}
 */
export const getPhoneVerificationCode = (params) => {
  return http.post('/code/getCode', params)
}

/**
 * 结束共享临时号码
 * @param {Object} params - 请求参数
 * @param {number} params.id - 任务ID
 * @param {string} params.phoneNo - 临时号码
 * @param {string} params.channelId - 渠道ID
 * @param {number} params.status - 状态（2表示结束共享）
 * @returns {Promise}
 */
export const releasePhoneNumber = (params) => {
  return http.post('/smsTask/updateTask', params)
}

/**
 * 将临时号码添加到屏蔽列表
 * @param {Object} params - 请求参数
 * @param {string} params.phoneNo - 临时号码
 * @param {string} params.channelId - 渠道ID
 * @param {string} params.code - 项目代码
 * @param {number} params.type - 类型（0表示屏蔽列表）
 * @returns {Promise}
 */
export const blacklistPhone = (params) => {
  return http.post('/phoneCollect/add', params)
}

/**
 * 添加问题反馈
 * @param {Object} params - 请求参数
 * @param {string} params.message - 反馈内容
 * @returns {Promise}
 */
export const addMessageReport = (params = {}) => {
  return http.post('/messageReport/add', params)
}

/**
 * 申请添加项目
 * @param {Object} params - 请求参数
 * @param {string} params.content - 数据内容示例
 * @returns {Promise}
 */
export const applyProject = (params = {}) => {
  return http.post('/applyProject/add', params)
}

/**
 * 获取用户消息
 * @param {Object} params - 请求参数
 * @param {number} params.page - 页码
 * @param {number} params.pageSize - 每页数量
 * @param {boolean} params.unread - 是否获取未读消息
 * @returns {Promise}
 */
export const getUserMessages = (params = {}) => {
  return http.post('/message/user/search', params)
}

/**
 * 标记用户消息为已读
 * @param {string} messageId - 消息ID
 * @returns {Promise}
 */
export const markUserMessageAsRead = (messageId) => {
  return http.get(`/message/user/read?id=${messageId}`)
}

/**
 * 获取最新公告
 * @returns {Promise}
 */
export const getLatestNotice = () => {
  return http.post('/notice/getLastOne', {})
}

/**
 * 获取当前用户进行中的任务
 * @returns {Promise}
 */
export const getTask = () => {
  return http.post('/smsTask/getTask', {})
}

/**
 * 激活卡密
 * @param {string} cardId - 卡密编号
 * @returns {Promise}
 */
export const activateCard = (cardId) => {
  return http.post('/idCard/activateCard', { cardId })
}

/**
 * 获取USDT充值地址和汇率
 * @returns {Promise}
 */
export const getUsdtQuotedPrice = () => {
  return http.post('/usdtRecharge/quotedPrice', {})
}

/**
 * 计算USDT转账金额
 * @param {number} rechargeMoney - 充值金额
 * @returns {Promise}
 */
export const calcUsdtPrice = (rechargeMoney) => {
  return http.post('/usdtRecharge/calcPrice', { rechargeMoney })
}

/**
 * 检查USDT充值是否成功
 * @param {number} id - 充值ID
 * @returns {Promise}
 */
export const checkUsdtRecharge = (id) => {
  return http.post('/usdtRecharge/rechargeIsSucc', { id })
}

/**
 * 创建易支付订单
 * @param {Object} params - 支付参数
 * @param {string} params.type - 支付类型 (alipay, wxpay)
 * @param {number} params.money - 支付金额
 * @param {string} [params.name] - 商品名称
 * @param {string} [params.device] - 设备类型
 * @param {string} [params.param] - 自定义参数
 * @returns {Promise}
 */
export const createEasyPayOrder = (params) => {
  return http.post('/easyPayRecharge/createOrder', params)
}

/**
 * 查询易支付结果
 * @param {string} tradeNo - 易支付交易号
 * @returns {Promise}
 */
export const checkEasyPayResult = (tradeNo) => {
  return http.post('/easyPayRecharge/rechargeIsSucc', { tradeNo })
}

/**
 * 获取易支付订单信息（无需登录）
 * @param {string} outTradeNo - 订单号
 * @returns {Promise}
 */
export const getEasyPayOrderInfo = (outTradeNo) => {
  return http.get('/easyPayRecharge/getOrderInfo', {
    params: { outTradeNo },
    skipAuth: true // 标记此接口不需要认证
  })
} 